export default __webpack_public_path__ + "static/media/incomplete_checkbox.374528b7.svg";